import http from "../axiosInterceptors"

const AuthService = {
    async UserLogin(userData) {
        const response = await http.post('/api/v1/login', userData)
        return response
    }
}

export default AuthService